var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path10, _g4, _path11, _g5, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlappedCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 115,
    viewBox: "0 0 128 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5309_287028)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5309_287028",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 42,
    width: 37,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2226 42.1084H28.6248V70.9934H64.2226V42.1084Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5309_287028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8205 71.0042C57.0922 64.6714 60.0705 58.9634 64.2226 54.3107C57.5705 46.8472 47.8748 42.1191 37.027 42.1191C34.1357 42.1191 31.3313 42.4961 28.6248 43.1315C31.3966 56.8955 42.1031 67.7947 55.8205 71.0149",
    fill: "#14743B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8205 71.0042C57.0922 64.6714 60.0705 58.9634 64.2226 54.3107C57.5705 46.8472 47.8748 42.1191 37.027 42.1191C34.1357 42.1191 31.3313 42.4961 28.6248 43.1315C31.3966 56.8955 42.1031 67.7947 55.8205 71.0149",
    fill: "#65A2B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2227 54.3108C70.8749 46.8472 80.5705 42.1192 91.4183 42.1192C94.3096 42.1192 97.114 42.4961 99.8205 43.1316C100.288 40.8376 100.527 38.4682 100.527 36.0449C100.527 16.1636 84.277 0.0625 64.2227 0.0625C44.1683 0.0625 27.9183 16.1636 27.9183 36.0342C27.9183 38.4574 28.1683 40.8268 28.6249 43.1208C31.3314 42.4854 34.1249 42.1084 37.027 42.1084C47.864 42.1084 57.5705 46.8364 64.2227 54.3",
    fill: "#94B59A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8205 71.004C42.114 67.7838 31.4074 56.8846 28.6248 43.1206C12.6357 46.8793 0.722656 61.0957 0.722656 78.0907C0.722656 97.9612 16.9727 114.062 37.027 114.062C47.864 114.062 57.5705 109.334 64.2227 101.871C58.5705 95.5272 55.114 87.2236 55.114 78.0907C55.114 75.6674 55.364 73.298 55.8205 71.004Z",
    fill: "#8FC3E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8205 43.1206C97.0487 56.8846 86.3422 67.7838 72.6248 71.004C73.0922 73.298 73.3314 75.6674 73.3314 78.0907C73.3314 87.2236 69.8748 95.5272 64.2227 101.871C70.8748 109.334 80.5705 114.062 91.4183 114.062C111.473 114.062 127.723 97.9505 127.723 78.0907C127.723 61.0957 115.81 46.8901 99.8205 43.1206Z",
    fill: "#FCF1A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5309_287028",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 42,
    width: 36,
    height: 29
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8205 42.1084H64.2227V70.9934H99.8205V42.1084Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5309_287028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2227 54.3108C68.3748 58.9634 71.3531 64.6715 72.6248 71.0042C86.3314 67.784 97.0379 56.8848 99.8205 43.1208C97.114 42.4853 94.3096 42.1084 91.4183 42.1084C80.5814 42.1084 70.8748 46.8364 64.2227 54.3",
    fill: "#14743B"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2227 54.3108C68.3748 58.9634 71.3531 64.6715 72.6248 71.0042C86.3314 67.784 97.0379 56.8848 99.8205 43.1208C97.114 42.4853 94.3096 42.1084 91.4183 42.1084C80.5814 42.1084 70.8748 46.8364 64.2227 54.3",
    fill: "#C3C470"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5309_287028",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 71,
    width: 19,
    height: 31
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3314 71.0044H55.1031V101.871H73.3314V71.0044Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5309_287028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.6246 71.0044C69.9181 71.6398 67.1138 72.006 64.2225 72.006C61.3312 72.006 58.5159 71.6291 55.8203 71.0044C55.3529 73.2984 55.1138 75.657 55.1138 78.091C55.1138 87.2239 58.5703 95.5276 64.2333 101.871C69.8855 95.5276 73.342 87.2239 73.342 78.091C73.342 75.6678 73.092 73.2984 72.6355 71.0044",
    fill: "#049ACF"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6248 71.0044C69.9183 71.6398 67.114 72.006 64.2226 72.006C61.3313 72.006 58.5161 71.6291 55.8205 71.0044C55.3531 73.2984 55.114 75.657 55.114 78.091C55.114 87.2239 58.5705 95.5276 64.2335 101.871C69.8857 95.5276 73.3422 87.2239 73.3422 78.091C73.3422 75.6678 73.0922 73.2984 72.6357 71.0044",
    fill: "#CCCF96"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5309_287028",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 54,
    width: 18,
    height: 19
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6248 54.3105H55.8205V72.0164H72.6248V54.3105Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5309_287028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8205 71.004C58.527 71.6394 61.3314 72.0056 64.2227 72.0056C67.114 72.0056 69.9292 71.6286 72.6248 71.004C71.3422 64.6712 68.3748 58.9632 64.2227 54.3105C60.0705 58.9632 57.0922 64.6712 55.8205 71.004Z",
    fill: "#14743B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5309_287028",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 54,
    width: 18,
    height: 19
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6248 54.3105H55.8205V72.0164H72.6248V54.3105Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5309_287028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8205 71.004C58.527 71.6394 61.3314 72.0056 64.2227 72.0056C67.114 72.0056 69.9292 71.6286 72.6248 71.004C71.3422 64.6712 68.3748 58.9632 64.2227 54.3105C60.0705 58.9632 57.0922 64.6712 55.8205 71.004Z",
    fill: "#049ACF"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8205 71.004C58.527 71.6394 61.3314 72.0056 64.2227 72.0056C67.114 72.0056 69.9292 71.6286 72.6248 71.004C71.3422 64.6712 68.3748 58.9632 64.2227 54.3105C60.0705 58.9632 57.0922 64.6712 55.8205 71.004Z",
    fill: "#B6C082"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5309_287028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 114,
    fill: "white",
    transform: "translate(0.722656 0.0625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlappedCircles);
export default __webpack_public_path__ + "static/media/overlapped-circles.96131de7ff4770b55bbbf418f79aa77f.svg";
export { ForwardRef as ReactComponent };